// extracted by mini-css-extract-plugin
export default {"homeLink":"_3OreJnPmETvrHYj-9UnQm4","categoryLink":"_231hJMktxeEHKn3ckPjPxe","image":"_3SI7Sbd4WMzn2A-UlarLgw"};